import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-category',
    imports: [RouterModule, NgOptimizedImage],
    templateUrl: './category.component.html',
    styleUrl: './category.component.scss',
    standalone: true
})
export class CategoryComponent { }
